import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-8e683922"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "tips hairlines"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_tips_alert = _resolveComponent("tips-alert");

  var _component_tips_error = _resolveComponent("tips-error");

  var _component_tips_loading = _resolveComponent("tips-loading");

  var _component_tips_confirm = _resolveComponent("tips-confirm");

  var _component_tips_success = _resolveComponent("tips-success");

  var _component_tips_toast = _resolveComponent("tips-toast");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_tips_alert, {
    show: _ctx.alert.show,
    "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.alert.show = $event;
    }),
    status: _ctx.alert.status,
    "is-show-status": _ctx.alert.isShowStatus,
    text: _ctx.alert.text,
    "button-text": _ctx.alert.buttonText,
    onConfirm: _ctx.alert.confirm
  }, null, 8, ["show", "status", "is-show-status", "text", "button-text", "onConfirm"]), _createVNode(_component_tips_error, {
    show: _ctx.err.show,
    "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.err.show = $event;
    }),
    text: _ctx.err.text
  }, null, 8, ["show", "text"]), _createVNode(_component_tips_loading, {
    show: _ctx.loading.show
  }, null, 8, ["show"]), _createVNode(_component_tips_confirm, {
    show: _ctx.confirm.show,
    "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.confirm.show = $event;
    }),
    options: _ctx.confirm.options,
    text: _ctx.confirm.text,
    onConfirm: _ctx.confirm.confirm,
    onCancel: _ctx.confirm.cancel
  }, null, 8, ["show", "options", "text", "onConfirm", "onCancel"]), _createVNode(_component_tips_success, {
    show: _ctx.success.show,
    "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.success.show = $event;
    }),
    text: _ctx.success.text,
    onConfirm: _ctx.success.callback
  }, null, 8, ["show", "text", "onConfirm"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toast.list, function (options) {
    return _openBlock(), _createBlock(_component_tips_toast, {
      key: options.count,
      options: options,
      "onUpdate:options": function onUpdateOptions($event) {
        return _ctx.toast.list = _ctx.toast.list.filter(function (item) {
          return item !== options;
        });
      }
    }, null, 8, ["options", "onUpdate:options"]);
  }), 128))]);
}